import { trackAction } from '@tcc/analytics';

export function trackEvent(noun, verb, params) {
  trackAction(`fieldview.weather.${noun}.${verb}`, params);
}
